import { displayAxiosError, hideLoadingOverlay, showLoadingOverlay } from '@/js/helpers/utils';
import { productClient } from '@/js/helpers/backend-clients';
import router from '@/router';

const state = {
  produkt: undefined,
  kaufdatumVon: undefined,
  kaufdatumBis: undefined,
  postleitzahl: undefined,
  ort: undefined,
  strasse: undefined,
  hausnummer: undefined,
  produktListe: [],
};

const mutations = {
  SET_PRODUKT(state, payload) {
    state.produkt = payload;
  },
  SET_KAUFDATUM_VON(state, payload) {
    state.kaufdatumVon = payload;
  },
  SET_KAUFDATUM_BIS(state, payload) {
    state.kaufdatumBis = payload;
  },
  SET_POSTLEITZAHL(state, payload) {
    state.postleitzahl = payload;
  },
  SET_ORT(state, payload) {
    state.ort = payload;
  },
  SET_STRASSE(state, payload) {
    state.strasse = payload;
  },
  SET_HAUSNUMMER(state, payload) {
    state.hausnummer = payload;
  },
  UPDATE_PRODUKT_LISTE(state, payload) {
    state.produktListe = payload;
  },
};

const actions = {
  setProdukt({ commit }, payload) {
    commit('SET_PRODUKT', payload);
  },
  setKaufdatumVon({ commit }, payload) {
    commit('SET_KAUFDATUM_VON', payload);
  },
  setKaufdatumBis({ commit }, payload) {
    commit('SET_KAUFDATUM_BIS', payload);
  },
  setPostleitzahl({ commit }, payload) {
    commit('SET_POSTLEITZAHL', payload);
  },
  setOrt({ commit }, payload) {
    commit('SET_ORT', payload);
  },
  setStrasse({ commit }, payload) {
    commit('SET_STRASSE', payload);
  },
  setHausnummer({ commit }, payload) {
    commit('SET_HAUSNUMMER', payload);
  },
  ladeProduktnamen({ commit }) {
    showLoadingOverlay();
    productClient
      .produktnamen()
      .then(({ data }) => {
        commit('UPDATE_PRODUKT_LISTE', data);
      })
      .catch(error => {
        displayAxiosError(error);
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          router.push('/login').finally();
        }
      })
      .finally(() => {
        hideLoadingOverlay();
      });
  },
};

const getters = {
  produkt: () => {
    return state.produkt;
  },

  kaufdatumVon: () => {
    return state.kaufdatumVon;
  },

  kaufdatumBis: () => {
    return state.kaufdatumBis;
  },

  postleitzahl: () => {
    return state.postleitzahl;
  },

  ort: () => {
    return state.ort;
  },

  strasse: () => {
    return state.strasse;
  },

  hausnummer: () => {
    return state.hausnummer;
  },
  produktnamen: () => {
    return state.produktListe;
  },
};

const gekaufteProdukteFilterModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default gekaufteProdukteFilterModule;
